import { useLabelParts } from '../config/useLabels';
import type { LabelKey } from '../config/labels';

interface BilingualLabelProps {
  keyName: LabelKey;
  /** Extra classes for the wrapper (applied in both modes). */
  className?: string;
}

/**
 * Renders a bilingual label with 中文 as the primary line and English below it
 * in smaller, dimmer text — sized for tight spots like the bottom-nav label
 * under an icon. On an English-only brand, renders English only.
 *
 * These labels are meaningful (not decorative), so unlike SectionGlyph they are
 * NOT aria-hidden.
 */
export function BilingualLabel({ keyName, className = '' }: BilingualLabelProps) {
  const get = useLabelParts();
  const { en, zh } = get(keyName);

  if (!zh) {
    return <span className={className}>{en}</span>;
  }

  return (
    <span className={`flex flex-col items-center leading-none ${className}`}>
      <span className="text-[0.95em]">{zh}</span>
      <span className="text-[0.7em] opacity-80">{en}</span>
    </span>
  );
}
